<script setup lang="ts">
import type { ArticoloRivista } from "@gasparigit/omnia-sdk";
import { link } from "~/lib/utils/contents";

defineProps<{
  content: ArticoloRivista;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props">
    <template v-if="content.capitolo?.numero_rivista" #preview>
      <div
        class="font-mono flex flex-col items-start justify-center text-base pe-4 border-e-2 border-primary mb-2 md:mb-0 min-w-28"
      >
        <span class="text-2xl text-primary font-semibold">{{
          content.capitolo.numero_rivista.number
        }}</span>
        <template v-if="content.capitolo.numero_rivista.published_at">
          <span>{{
            content.capitolo.numero_rivista.published_at.toLocaleString(
              "default",
              { month: "long" }
            )
          }}</span>
          <span>{{
            content.capitolo.numero_rivista.published_at.getFullYear()
          }}</span>
        </template>
      </div>
    </template>
    <template v-if="content.overtitle" #info>
      <span class="info-number mt-2 md:mt-0">{{ content.overtitle }}</span>
    </template>
    <template v-if="content.capitolo?.numero_rivista?.rivista" #header>
      <NuxtLink
        :to="
          link({
            rivista: content.capitolo?.numero_rivista.rivista,
            numeroRivista: content.capitolo?.numero_rivista,
          })
        "
        class="text-primary font-semibold mb-1"
      >
        {{ content.capitolo.numero_rivista.rivista.title }}
      </NuxtLink>
    </template>
    <template v-if="content.author" #center>
      <span class="text-themeGray font-thin mt-3"
        >A cura di {{ content.author }}</span
      >
    </template>
  </FrontContentItemsBaseContent>
</template>
